import { staticUrl } from "~utils"

/** 本地预览 / 绝对地址原样返回，相对路径走 CDN */
export function resolveAvatarUri(uri?: string) {
  if (!uri) return ""
  if (/^(blob|file|content|data):/i.test(uri)) return uri
  if (/^https?:\/\//i.test(uri)) return uri
  return staticUrl(uri)
}
